module.exports = __webpack_public_path__ + "pic/46.f0f8d788.png";